module.exports = __webpack_public_path__ + "static/media/3_Unfomfortable.72e547a7.svg";